import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useForm } from 'react-hook-form'
import { GoogleIcon } from '@slite/icons'

import {
  setUserCredentials,
  setUserPositionInformations,
  getErrors,
  getInviteToken,
  getUser,
} from './state'

import { getConfig } from 'config'
import { urls } from '../urls'

import {
  ButtonHTMLLink,
  HorizontalRule,
  LegalText,
  Main,
} from '../../../components'

import { SelectOption } from '../../../components/Select/ControlledSelect'
import { UserStepInput } from '../../../components/Forms/UserStep'
import { useCallback } from 'react'
import { useQueryParams } from 'hooks/useQueryParams'
import { AcceptInvitationQueryParams } from './types'
import { FormattedMessage } from 'react-intl'

type FormData = {
  password: string
  displayName: string
  goal: SelectOption
}

export function UserStep({ superEnabled }: { superEnabled: boolean }) {
  const dispatch = useDispatch()
  const config = useSelector(getConfig)
  const inviteToken = useSelector(getInviteToken)
  const user = useSelector(getUser)
  const errors = useSelector(getErrors)
  const { organizationId, organizationName } =
    useQueryParams<AcceptInvitationQueryParams>()

  const ssoLoginUrl = useSelector(() =>
    urls.getLoginUrl(
      config,
      { organizationId, inviteToken },
      { forceGoogleLogin: true }
    )
  )

  const { control, handleSubmit, formState } = useForm<FormData>({
    mode: 'onChange',
    defaultValues: {
      password: '',
      displayName: user.displayName ?? '',
    },
  })

  const onSubmit = useCallback(
    (data: FormData) => {
      dispatch(
        setUserCredentials({
          password: data.password,
        })
      )
      dispatch(
        setUserPositionInformations({
          displayName: data.displayName,
          acceptedPrivacyPolicy: true,
        })
      )
    },
    [dispatch]
  )

  return (
    <Main.Container>
      <Main.Title>
        <FormattedMessage
          id="boarding.joinSliteTeam.title"
          defaultMessage="Join the {product} team"
          values={{ product: superEnabled ? 'Super' : 'Slite' }}
        />
        <br />
        {!!organizationName && (
          <span className="capitalize">{organizationName}</span>
        )}
      </Main.Title>
      <div className="flexbox flexbox-column">
        {ssoLoginUrl && (
          <>
            <ButtonHTMLLink
              variant="secondary"
              href={ssoLoginUrl}
              icon={GoogleIcon}
            >
              <FormattedMessage
                id="boarding.joinSliteTeam.google"
                defaultMessage="Continue with Google"
                values={{}}
              />
            </ButtonHTMLLink>

            <HorizontalRule />
          </>
        )}

        <UserStepInput<FormData>
          onSubmit={handleSubmit(onSubmit)}
          control={control}
          displayName="displayName"
          password="password"
          isValid={formState.isValid && !errors.fetch && !errors.accept}
        />
      </div>
      <LegalText />
    </Main.Container>
  )
}
